import React from 'react'
import NavLink from './NavLink'

const NavGroup = ({ id, target, emphasize, inverted }) => (
  <li key={id} className="block px-3 group first:pl-0 last:pr-0">
    <NavLink target={target} emphasize={emphasize} inverted={inverted} />
  </li>
)

export default NavGroup
